import { UserInfo } from 'src/core/authentication/domain/user-info';

export class UserLoggedInEvent {
  constructor(public readonly user: UserInfo) {}
}
